import Icon from "@mdi/react";
import { Flex } from "antd";
import React, { useEffect, useState } from "react";
import { CRUISE_CATEGORY } from "../../../utils/helpers";
import Legends, { LEGEND_ICONS } from "./Legends";
import dayjs from 'dayjs';
import { mdiMenuRight, mdiMenuLeft } from "@mdi/js";

const TourDateSelector2 = (
  props: {
    dates: any[],
    selectedDate: string,
    selectedTourCode: any,
    selectTour: Function,
    category: string,
    isNew?: boolean
  }
) => {
  const { dates, selectedDate, selectedTourCode, selectTour, category } = props;
  const isCruise = category === CRUISE_CATEGORY;

  const containerRef = React.useRef<HTMLDivElement>(null);
  const [isScrollable, setIsScrollable] = useState(false);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const [isDown, setIsDown] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const updateScrollState = () => {
    const el = containerRef.current;
    if (!el) return;

    const scrollable = el.scrollWidth > el.clientWidth;
    setIsScrollable(scrollable);

    setCanScrollLeft(el.scrollLeft > 10);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
  };

  const onMouseDown = (e: React.MouseEvent) => {
    const el = containerRef.current;
    if (!el) return;

    setIsDown(true);
    setStartX(e.pageX - el.offsetLeft);
    setScrollLeft(el.scrollLeft);
  };

  const onMouseMove = (e: React.MouseEvent) => {
    if (!isDown) return;
    const el = containerRef.current;
    if (!el) return;

    e.preventDefault();
    const x = e.pageX - el.offsetLeft;
    const walk = (x - startX) * 1.5;
    el.scrollLeft = scrollLeft - walk;
  };

  const onMouseUpOrLeave = () => setIsDown(false);

  const scroll = (direction: "left" | "right") => {
    const el = containerRef.current;
    if (!el) return;

    const amount = 125; // card width + gap
    el.scrollBy({
      left: direction === "left" ? -amount : amount,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    updateScrollState();
    window.addEventListener("resize", updateScrollState);
    return () => window.removeEventListener("resize", updateScrollState);
  }, []);

  return (
    <Flex gap={15} vertical className="tour-date-selector v2">
      <div className={`wrapper ${isScrollable ? "has-arrows" : ""}`}>
        {
          isScrollable && 
            <button 
              className="arrows arrows-prev" 
              disabled={!canScrollLeft} 
              onClick={() => scroll("left")}> 
                <Icon path={mdiMenuLeft} size={1.5} /> 
            </button>
        }

        <div 
          ref={containerRef} 
          className={`scroller ${!canScrollRight ? "end" : ""}`}
          onScroll={updateScrollState}
          onMouseDown={onMouseDown}
          onMouseMove={onMouseMove}
          onMouseUp={onMouseUpOrLeave}
          onMouseLeave={onMouseUpOrLeave}>
          { 
            dates.map((tour:{ date: string; code: string; type: string; price: string, indicator: string }) => {
              const iconPath = LEGEND_ICONS[tour.type as keyof typeof LEGEND_ICONS];
              const tourDate = dayjs(tour.date, "DD/MM/YYYY").toDate();
              const tourYear = tourDate.getFullYear();
              const tourDateFormatted = dayjs(tourDate).format("DD MMM");
              const selected = selectedDate ? (selectedDate == tour.date && selectedTourCode == tour.code) : selectedTourCode == tour.code;
              return (
                <div
                  key={tour.code} 
                  className={`date-box ${!isCruise && tour.type} ${(selected) && "selected"}`} 
                  onClick={()=>selectTour(tour)} >   

                  {
                    (!isCruise && !selected && iconPath) && <span className={`guaranteed-indicator-icon ${tour.type}`}> <Icon path={iconPath} size={1.5}/>  </span>
                  }

                  <Flex 
                    justify="space-between" 
                    align="center" 
                    vertical 
                    gap={10}>
                    <div className="date-box_date"> 
                      <span>{tourYear}</span>
                      <b>{tourDateFormatted}</b>
                    </div>
                    <div>
                      <span>From</span>
                      <div className="date-box_price"> {tour.price} </div>
                      <div className="tour-indicator"> {tour.indicator && <small>{tour.indicator}</small>} </div>
                    </div>
                  </Flex>

                </div>
              )
            })
          }
        </div>

        {canScrollRight && <div className="fade-mask" />}

        {
          isScrollable && 
            <button 
              className={`arrows arrows-next ${!canScrollRight ? "end" : ""}`}
              onClick={() => scroll("right")}
              disabled={!canScrollRight}> 
                <Icon path={mdiMenuRight} size={1.5} /> 
            </button>
        }

      </div>

      { !isCruise && <Legends />}
    </Flex>
  );
};

export default TourDateSelector2;